import { ThumbnailInfo } from '@app/core/hooks/api/useApiThumbnailsRange';
import { renderMaybeFn } from '@mi-front/core';
import { useEffect, useRef, useState } from 'react';
import { Stream, StreamProps } from '../stream/Stream';
import { ThumbnailsLoading } from './ThumbnailsLoading';
import { ThumbnailsRoll } from './ThumbnailsRoll';

interface Props extends StreamProps {
  readonly thumbnails: ThumbnailInfo[];
  readonly thumbnailsLoading: boolean;
}

const THUMB_HEIGHT = 81;

export function ThumbnailsStream(p: Props) {
  const { thumbnails, thumbnailsLoading, ...rest } = p;
  const ref = useRef<HTMLDivElement>();

  const [showLoading, setShowLoading] = useState(true);

  // Hide loading after 3 seconds when thumbnails loaded
  // This is to avoid the it closing too early before the css sprites
  // in the roll are completely displayed
  useEffect(() => {
    if (!thumbnailsLoading) {
      setTimeout(() => {
        setShowLoading(false);
      }, 3000);
    }
  }, [thumbnailsLoading]);

  return (
    <Stream
      {...rest}
      compressed
      containerRef={ref}
      htmlBehindSvg
      renderHtml={() => showLoading && <ThumbnailsLoading />}
      renderSvg={() => (
        <>
          {!thumbnailsLoading && ref.current && (
            <ThumbnailsRoll
              streamEl={ref.current}
              thumbHeight={THUMB_HEIGHT}
              thumbnails={thumbnails}
            />
          )}
          {renderMaybeFn(p.renderSvg)}
        </>
      )}
    />
  );
}
